<template>
  <div class="findings-control">
    <div class="section-row">
      <!-- OD SIDE -->
      <div class="md-size-35">
        <div class="section-column">
          <!-- FINDINGS OD -->
          <div class="section-row">
            <div class="cards" style="max-width: 60%">
              <md-card style="width: 240px; height: 193px; margin-bottom: 7px" class="md-with-hover">
                <md-card-content style="padding: 0px 0px" align="Center">
                  <label class="md-caption">
                    <b>Findings OD</b>
                  </label>

                  <hr style="padding: 0px; margin: 0px 0px 10px 0px" />

                  <div class="md-layout md-layout-item" align="Left">
                    <!-- Multi-select options -->
                    <div v-if="topFiveCards.OD.length > 0" class="top-options">
                      <div
                        v-for="option in topFiveCards.OD"
                        :key="option.id"
                        class="option-item"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                        style="font-size: 0.95em; line-height: 1.7em"
                      >
                        <label>
                          <input
                            :value="option"
                            v-model="selectedItemsOD"
                            :disabled="cltNormalStyle"
                            type="checkbox"
                            @change="newCheckFinding(option, $event)"
                          />
                          {{ option.observation }}
                        </label>
                      </div>
                      <div
                        v-if="topFiveCards.OD.length == 0"
                        class="option-item"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                        style="font-size: 0.95em; line-height: 1.7em"
                      >
                        <p>No findings found for this modality. Create new ones at DxSearch</p>
                      </div>
                    </div>

                    <!-- Search box with autocomplete -->
                    <div>
                      <div
                        v-if="topFiveCards.OD.length > 0"
                        class="search-box"
                        style="
                          margin-top: 5px;
                          border-style: solid;
                          border-width: 1px;
                          border-color: #a0a0a0;
                          border-radius: 5px;
                        "
                      >
                        <i
                          ><input
                            v-model="searchQueryOD"
                            :disabled="cltNormalStyle"
                            type="text"
                            size="17"
                            style="
                              padding-left: 5px;
                              border-style: none;
                              background-color: #f1f1f1;
                              color: rgba(2, 119, 189);
                              font-weight: 400;
                              font-size: 0.75rem;
                              width: 145px;
                            "
                            placeholder="search for findings"
                            @input="updateAutocompleteOD"
                        /></i>
                        <span>
                          <button
                            :disabled="btnAddFindingDisabledOD"
                            :style="btnAddFindingStyleOD"
                            style="
                              padding: 0px 8px;
                              margin: 0px 0px 0px 0px;
                              border-style: solid;
                              border-width: 1px;
                              border-color: #a0a0a0;
                              border-radius: 5px;
                            "
                            @click="addFinding(searchQueryOD, 'OD')"
                          >
                            Add
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </md-card-content>
              </md-card>

              <div align="Left" style="width: 220px; margin-left: 7px">
                <ul
                  v-if="autocompleteSuggestionsOD.length"
                  class="autocomplete-list"
                  style="font-size: 0.9em; font-weight: 500; color: rgba(2, 119, 189); font-style: italic"
                >
                  <ul
                    v-for="suggestion in autocompleteSuggestionsOD"
                    :key="suggestion.id"
                    onMouseOver="this.style.backgroundColor='#e3f2fd'"
                    onMouseOut="this.style.backgroundColor='#FFFFFF'"
                    style="font-size: 1em; line-height: 1.65em"
                    @click="selectSuggestionOD(suggestion)"
                  >
                    {{
                      suggestion.observation
                    }}
                  </ul>
                </ul>
              </div>
            </div>

            <!-- STATIC OD -->
            <div class="cards" style="max-width: 40%">
              <md-card style="width: 175px; height: 193px; margin-bottom: 7px" class="md-with-hover">
                <md-card-content style="padding: 0px 0px" align="Center">
                  <label class="md-caption">
                    <b>Other Findings OD</b>
                  </label>

                  <hr style="padding: 0px; margin: 0px 0px 10px 0px" />

                  <div v-if="staticOptions('OD').length > 4" class="md-layout md-layout-item" align="Left">
                    <div class="static-options">
                      <label
                        style="color: rgba(0, 98, 211, 0.8); font-size: 1.1em; font-weight: 400"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                      >
                        <input
                          v-model="normal_OD"
                          :disabled="cltNormalStyle"
                          value=""
                          type="checkbox"
                          @click="normalODChanged(staticOptions('OD')[0])"
                        />
                        {{ staticOptions("OD")[0].observation }}
                      </label>

                      <div
                        v-for="option in staticOptions('OD').slice(1, 4)"
                        :key="option.id"
                        class="option-item"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                        style="font-size: 0.95em; line-height: 1.7em"
                      >
                        <label>
                          <input
                            :value="option"
                            v-model="selectedItemsOD"
                            :disabled="cltNormalStyle"
                            type="checkbox"
                            @change="newCheckFinding(option, $event)"
                          />
                          {{ option.observation }}
                        </label>
                      </div>

                      <label
                        style="color: #ff9800; font-size: 0.97em; font-weight: 400"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                      >
                        <input
                          v-model="nottested_OD"
                          :disabled="cltNormalStyle"
                          type="checkbox"
                          value=""
                          @click="nottestedODChanged(staticOptions('OD')[4])"
                        />
                        {{ staticOptions("OD")[4].observation }}
                      </label>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
          <!-- Findings DISPLAY OD -->
          <div
            :id="sectionName + '-OD'"
            class="values2 md-layout-item"
            style="font-family: 'Roboto', sans-serif; font-size: 16px; max-width: 460px"
          >
            <span v-if="normal_OD">OD: <span style="color: blue; font-weight: 400">Normal</span></span>
            <span v-else>
              <span v-if="valuesOD.length > 0"
                >OD: <span style="color: red">{{ valuesOD }}</span></span
              >
            </span>
          </div>
        </div>
      </div>

      <!-- OS SIDE -->
      <div class="md-size-35">
        <div class="section-column">
          <div class="section-row">
            <!-- FDINDINGS OS -->
            <div class="cards" style="max-width: 60%">
              <md-card style="width: 240px; height: 193px; margin-bottom: 7px" class="md-with-hover">
                <md-card-content style="padding: 0px 0px" align="Center">
                  <label class="md-caption">
                    <b>Findings OS</b>
                  </label>

                  <hr style="padding: 0px; margin: 0px 0px 10px 0px" />

                  <div class="md-layout md-layout-item" align="Left">
                    <!-- Multi-select options -->

                    <div v-if="topFiveCards.OS.length > 0" class="top-options">
                      <div
                        v-for="option in topFiveCards.OS"
                        :key="option.id"
                        class="option-item"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                        style="font-size: 0.95em; line-height: 1.7em"
                      >
                        <label> 
                          <input
                            :value="option"
                            v-model="selectedItemsOS"
                            :disabled="cltNormalStyle"
                            type="checkbox"
                            @change="newCheckFinding(option, $event)"
                          />
                          {{ option.observation }}
                        </label>
                      </div>
                      <div
                        v-if="topFiveCards.OS.length == 0"
                        class="option-item"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                        style="font-size: 0.95em; line-height: 1.7em"
                      >
                        <p>No findings found for this modality. Create new ones at DxSearch</p>
                      </div>
                    </div>

                    <!-- Search box with autocomplete -->
                    <div
                      v-if="topFiveCards.OS.length > 0"
                      class="search-box"
                      style="
                        margin-top: 5px;
                        border-style: solid;
                        border-width: 1px;
                        border-color: #a0a0a0;
                        border-radius: 5px;
                      "
                    >
                      <i
                        ><input
                          v-model="searchQueryOS"
                          :disabled="cltNormalStyle"
                          type="text"
                          size="17"
                          style="
                            padding-left: 5px;
                            border-style: none;
                            background-color: #f1f1f1;
                            color: rgba(2, 119, 189);
                            font-weight: 400;
                            font-size: 0.75rem;
                            width: 145px;
                          "
                          placeholder="search for findings"
                          @input="updateAutocompleteOS"
                      /></i>
                      <span>
                        <button
                          :disabled="btnAddFindingDisabledOS"
                          :style="btnAddFindingStyleOS"
                          style="
                            padding: 0px 8px;
                            margin: 0px 0px 0px 0px;
                            border-style: solid;
                            border-width: 1px;
                            border-color: #a0a0a0;
                            border-radius: 5px;
                          "
                          @click="addFinding(searchQueryOS, 'OS')"
                        >
                          Add
                        </button>
                      </span>
                    </div>
                  </div>
                </md-card-content>
              </md-card>

              <div align="Left" style="width: 220px; margin-left: 7px">
                <ul
                  v-if="autocompleteSuggestionsOS.length"
                  class="autocomplete-list"
                  style="font-weight: 500; color: rgba(2, 119, 189); font-style: italic"
                >
                  <ul
                    v-for="suggestion in autocompleteSuggestionsOS"
                    :key="suggestion.id"
                    onMouseOver="this.style.backgroundColor='#e3f2fd'"
                    onMouseOut="this.style.backgroundColor='#FFFFFF'"
                    style="font-size: 1em; line-height: 1.65em"
                    @click="selectSuggestionOS(suggestion)"
                  >
                    {{
                      suggestion.observation
                    }}
                  </ul>
                </ul>
              </div>
            </div>
            <!-- STATIC OS -->
            <div class="cards" style="max-width: 40%">
              <md-card style="width: 175px; height: 193px; margin-bottom: 7px" class="md-with-hover">
                <md-card-content style="padding: 0px 0px" align="Center">
                  <label class="md-caption">
                    <b>Other Findings OS</b>
                  </label>

                  <hr style="padding: 0px; margin: 0px 0px 10px 0px" />

                  <div v-if="staticOptions('OS').length > 4" class="md-layout md-layout-item" align="Left">
                    <div class="static-options">
                      <label
                        style="color: rgba(0, 98, 211, 0.8); font-size: 1.1em; font-weight: 400"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                      >
                        <input
                          v-model="normal_OS"
                          :disabled="cltNormalStyle"
                          type="checkbox"
                          value=""
                          @click="normalOSChanged(staticOptions('OS')[0])"
                        />
                        {{ staticOptions("OS")[0].observation }}
                      </label>

                      <div
                        v-for="option in staticOptions('OS').slice(1, 4)"
                        :key="option.id"
                        class="option-item"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                        style="font-size: 0.95em; line-height: 1.7em"
                      >
                        <label>
                          <input
                            :value="option"
                            v-model="selectedItemsOS"
                            :disabled="cltNormalStyle"
                            type="checkbox"
                            @change="newCheckFinding(option, $event)"
                          />
                          {{ option.observation }}
                        </label>
                      </div>

                      <label
                        style="color: #ff9800; font-size: 0.97em; font-weight: 400"
                        onMouseOver="this.style.backgroundColor='#e3f2fd'"
                        onMouseOut="this.style.backgroundColor='#FFFFFF'"
                      >
                        <input
                          v-model="nottested_OS"
                          :disabled="cltNormalStyle"
                          type="checkbox"
                          value=""
                          @click="nottestedOSChanged(staticOptions('OS')[4])"
                        />
                        {{ staticOptions("OS")[4].observation }}
                      </label>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
          <!-- Findings DISPLAY OS -->
          <div
            :id="sectionName + '-OS'"
            class="values2 md-layout-item"
            style="font-family: 'Roboto', sans-serif; font-size: 16px; max-width: 460px"
          >
            <span v-if="normal_OS">OS: <span style="color: blue; font-weight: 400">Normal</span></span>
            <span v-else>
              <span v-if="valuesOS.length > 0"
                >OS: <span style="color: red">{{ valuesOS }}</span></span
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ROW Buttons Cluster -->
    <div class="md-layout md-alignment-space-around-center" style="text-align: center; margin-top: 20px">
      <td>
        <label>
          <md-card class="md-with-hover" style="width: 90px; margin: 5px; text-align: center">
            <md-card-content style="padding: 9px 7px">
              <div class="md-layout">
                <md-radio
                  v-model="normal"
                  :disabled="cltNormalStyle"
                  style="font-size: 11px; padding: 0px; margin: 0px; padding-bottom: 2px"
                  value="OU"
                  class="md-caption md-layout-item md-size-100"
                  @change="updtNormal"
                  >&nbsp;Normal</md-radio
                >
              </div>
            </md-card-content>
          </md-card>
        </label>
      </td>
      <td>
        <md-button :class="btnResetStyle" style="padding: 0px 6px; width: 35px; height: 40px" @click="resetSelections()"
          >Reset</md-button
        >
      </td>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"
import { stat } from "fs"

export default {
  name: "Top5Findings",
  props: {
    section: String,
    sectionName: String,
    mState: Boolean,
    bus: [bus]
  },
  components: {
    Modal
  },
  data() {
    return {
      screeningID: null,
      normal: false,
      normal_OD: false,
      normal_OS: false,
      normal_OU: false,
      nottested_OD: false,
      nottested_OS: false,
      searchDxModal: false,
      addState: false,
      findPlus: "",
      findPlusArr: [],
      normalStyle: false,
      maxID: 10000,
      savedEval: {},
      findingPayload: {},
      styleActive: {
        color: "black",
        "background-color": "#93e197",
        "font-weight": "400"
      },
      styleInActive: {
        color: "#66bb6a",
        "background-color": "white",
        "font-weight": "100"
      },

      findingsMaster: {
        External: 1,
        Cornea: 2,
        Pachymetry: 3,
        Opacity: 4,
        Fundus: 5,
        Macula: 6,
        Nerve: 7
      },

      selectedItemsOD: [],
      selectedItemsOS: [],
      selectedItemsOU: [],
      searchQueryOD: "",
      searchQueryOS: "",
      searchQueryOU: "",
      autocompleteSuggestionsOD: [],
      autocompleteSuggestionsOS: [],
      autocompleteSuggestionsOU: [],

      alwaysHide: ["NORMAL", "Essentially Normal", "Poor Image Quality", "Unreliable Test", "Not Tested", "Not tested"]
    }
  },

  computed: {
    ...mapGetters([
      "omniDiag",
      "omniPhoto",
      "findingsMaxID",
      "findingsMetrics",
      "getCardsByModality",
      "dxOptionsList",
      "createFinding",
      "getSavedFindings",
      "getOtherCardsByModality",
      "getAllCardsByModality",
      "screening"
    ]),
    otherDXCards() {
      return this.getOtherCardsByModality(this.sectionName)
    },
    valuesOD() {
      return this.selectedItemsOD.map((item) => item.observation || item.value).join(", ")
    },
    valuesOS() {
      return this.selectedItemsOS.map((item) => item.observation || item.value).join(", ")
    },
    valuesOU() {
      return this.selectedItemsOU.map((item) => item.observation || item.value).join(", ")
    },
    btnResetStyle() {
      return this.mState ? "md-primary" : ""
    },
    btnDxStyle() {
      return this.mState ? "md-warning" : ""
    },
    cltNormalStyle() {
      return this.mState ? this.normalStyle : "disabled"
    },

    btnAddFindingStyleOD() {
      const shouldEnableButton = this.searchQueryOD.length > 0 && this.autocompleteSuggestionsOD.length === 0
      return shouldEnableButton ? this.styleActive : this.styleInActive
    },
    btnAddFindingDisabledOD() {
      return !(this.searchQueryOD.length > 0 && this.autocompleteSuggestionsOD.length === 0)
    },
    btnAddFindingStyleOU() {
      const shouldEnableButton = this.searchQueryOU.length > 0 && this.autocompleteSuggestionsOU.length === 0
      return shouldEnableButton ? this.styleActive : this.styleInActive
    },
    btnAddFindingDisabledOU() {
      return !(this.searchQueryOU.length > 0 && this.autocompleteSuggestionsOU.length === 0)
    },

    btnAddFindingStyleOS() {
      const shouldEnableButton = this.searchQueryOS.length > 0 && this.autocompleteSuggestionsOS.length === 0
      return shouldEnableButton ? this.styleActive : this.styleInActive
    },
    btnAddFindingDisabledOS() {
      return !(this.searchQueryOS.length > 0 && this.autocompleteSuggestionsOS.length === 0)
    },

    btnNormalStyle() {
      return this.mState ? "" : "disabled"
    },
    dxCards() {
      return this.getCardsByModality(this.sectionName)
    },
    allDxCards() {
      return this.getAllCardsByModality(this.sectionName)
    },
    topFiveCards() {
      return {
        OU: this.dxCards.OU.slice(0, 5),
        OS: this.dxCards.OS.slice(0, 5),
        OD: this.dxCards.OD.slice(0, 5)
      }
    }
  },
  mounted() {
    bus.$on("omniReset", () => {
      this.initCurrStorage()
    })
    bus.$on("saveFindingsInStorage", () => {
      this.saveEval()
    })
  },
  beforeDestroy() {
    bus.$off("saveFindingsInStorage")
    bus.$off("omniReset")
  },
  watch: {
    allDxCards(newValue) {
      if (newValue) {
        this.fillSavedFindings()
      }
    },
    "createFinding.isCreate": {
      handler(newVal, oldVal) {
        if (oldVal && newVal === false && this.sectionName === this.createFinding.sectionName) {
          switch (this.createFinding.finding.eyeAffected) {
            case "OU":
              this.selectedItemsOU.push(this.createFinding.finding)
              this.searchQueryOU = ""
              break
            case "OS":
              this.selectedItemsOS.push(this.createFinding.finding)
              this.searchQueryOS = ""
              break
            case "OD":
              this.selectedItemsOD.push(this.createFinding.finding)
              this.searchQueryOD = ""
              break
            default:
              break
          }
          this.fetchDxCards({ orgID: this.screening.orgID, plain: false })
        }
      }
    }
  },

  methods: {
    ...mapActions([
      "addDxOption",
      "removeDxOption",
      "updateCreateFinding",
      "fetchDxCards",
      "updateSelectedFindingsIds"
    ]),
    staticOptions(eyeAffected) {
      const observationOrder = ["NORMAL", "Essentially Normal", "Poor Image Quality", "Unreliable Test", "Not Tested"]
      const otherCards = [...this.otherDXCards[eyeAffected]] // clone array
      return otherCards.sort((a, b) => {
        const indexA = observationOrder.indexOf(a.observation)
        const indexB = observationOrder.indexOf(b.observation)
        return indexA - indexB
      })
    },
    fillSavedFindings() {
      const savedFindings = this.getSavedFindings
      if (!savedFindings || !this.allDxCards) return
      savedFindings.forEach((f) => {
        let dxCard = this.allDxCards[f.eyeAffected].find((dx) => dx.id == f.dxCardID)
        switch (f.eyeAffected) {
          case "OD":
            if (dxCard) {
              this.selectedItemsOD.push(dxCard)
              this.addDxOption(dxCard)
              this.normal_OD = dxCard.observation.toLowerCase() === "normal"
              this.nottested_OD = dxCard.observation.toLowerCase() === "not tested"
            }
            break
          case "OS":
            if (dxCard) {
              this.selectedItemsOS.push(dxCard)
              this.addDxOption(dxCard)
              this.normal_OS = dxCard.observation.toLowerCase() === "normal"
              this.nottested_OS = dxCard.observation.toLowerCase() === "not tested"
            }
            break
          case "OU":
            if (dxCard) {
              this.selectedItemsOU.push(dxCard)
              this.addDxOption(dxCard)
              this.normal_OU = dxCard.observation.toLowerCase() === "normal"
              this.nottested_OU = dxCard.observation.toLowerCase() === "not tested"
            }
            break
          default:
            break
        }
      })
      this.$nextTick(() => {
        this.$forceUpdate()
      })

      this.propagateFindings()
    },
    mouseOver() {
      this.mState = true
    },
    mouseLeave() {
      this.mState = false
    },
    updateAutocompleteOD() {
      if (this.searchQueryOD.length > 0) {
        this.autocompleteSuggestionsOD = this.dxCards.OD.filter((item) =>
          item.observation.toLowerCase().includes(this.searchQueryOD.toLowerCase())
        ).slice(0, 7) // Limit to n suggestions
      } else {
        this.autocompleteSuggestionsOD = []
      }
    },
    updateAutocompleteOS() {
      if (this.searchQueryOS.length > 0) {
        this.autocompleteSuggestionsOS = this.dxCards.OS.filter((item) =>
          item.observation.toLowerCase().includes(this.searchQueryOS.toLowerCase())
        ).slice(0, 7) // Limit to n suggestions
      } else {
        this.autocompleteSuggestionsOS = []
      }
    },
    updateAutocompleteOU() {
      if (this.searchQueryOU.length > 0) {
        this.autocompleteSuggestionsOU = this.dxCards.OU.filter((item) =>
          item.observation.toLowerCase().includes(this.searchQueryOU.toLowerCase())
        ).slice(0, 7) // Limit to n suggestions
      } else {
        this.autocompleteSuggestionsOU = []
      }
    },
    selectSuggestionOD(suggestion) {
      if (this.normal_OD && suggestion.observation !== "NORMAL") {
        this.normal_OD = false;
        this.removeItemOD(this.staticOptions("OD")[0]); 
      }
      if (!this.selectedItemsOD.some((item) => item.id === suggestion.id)) {
        this.selectedItemsOD.push(suggestion)
      }
      this.searchQueryOD = ""
      this.autocompleteSuggestionsOD = []

      this.removeItemOD(this.staticOptions("OD")[0])
      this.normal_OD = false
      this.addDxOption(suggestion)
    },

    selectSuggestionOS(suggestion) {
      if (this.normal_OS && suggestion.observation !== "NORMAL") {
        this.normal_OS = false;
        this.removeItemOS(this.staticOptions("OS")[0]);
      }
      if (!this.selectedItemsOS.some((item) => item.id === suggestion.id)) {
        this.selectedItemsOS.push(suggestion)
      }
      this.searchQueryOS = ""
      this.autocompleteSuggestionsOS = []

      this.removeItemOS(this.staticOptions("OS")[0])
      this.normal_OS = false
      this.addDxOption(suggestion)
    },
    selectSuggestionOU(suggestion) {
      if (this.normal_OU && suggestion.observation !== "NORMAL") {
        this.normal_OU = false;
        this.removeItemOU(this.staticOptions("OU")[0]); 
      }
      if (!this.selectedItemsOU.some((item) => item.id === suggestion.id)) {
        this.selectedItemsOU.push(suggestion)
      }
      this.searchQueryOU = ""
      this.autocompleteSuggestionsOU = []
      this.removeItemOU(this.staticOptions("OU")[0])
      this.normal_OU = false
      this.addDxOption(suggestion)
    },
    removeItemOD(item) {
      try {
        const index = this.selectedItemsOD.findIndex((i) => i.id === item.id)
        if (index !== -1) {
          this.selectedItemsOD.splice(index, 1)
        }
        if (item.observation === "NORMAL") {
          this.normal_OD = false
        }
        this.propagateFindings()
      } catch (error) {
        console.log(error)
      }
    },
    removeItemOS(item) {
      try {
        const index = this.selectedItemsOS.findIndex((i) => i.id === item.id)
        if (index !== -1) {
          this.selectedItemsOS.splice(index, 1)
        }
        if (item.observation === "NORMAL") {
          this.normal_OS = false
        }
        this.propagateFindings()
      } catch (error) {
        console.log(error)
      }
    },
    removeItemOU(item) {
      try {
        const index = this.selectedItemsOU.findIndex((i) => i.id === item.id)
        if (index !== -1) {
          this.selectedItemsOU.splice(index, 1)
        }
        if (item.observation === "NORMAL") {
          this.normal_OU = false
        }
        this.propagateFindings()
      } catch (error) {
        console.log(error)
      }
    },
    resetSelections() {
      const combined = [...this.selectedItemsOD, ...this.selectedItemsOS, ...this.selectedItemsOU]
      const toRemove = combined.filter((sel) => this.dxOptionsList.some((dx) => dx.RSLT.id === sel.id))
      this.removeDxOption(toRemove)

      this.selectedItemsOD = []
      this.selectedItemsOS = []
      this.selectedItemsOU = []

      this.normal_OD = false
      this.normal_OS = false
      this.nottested_OD = false
      this.nottested_OS = false
      this.searchQueryOD = ""
      this.searchQueryOS = ""
      this.searchQueryOU = ""
      this.autocompleteSuggestionsOD = []
      this.autocompleteSuggestionsOS = []
      this.autocompleteSuggestionsOU = []
      // Reset FindingPopUp
      this.findPlus = ""
      this.findPlusArr = []

      this.omniPhoto(this.section).findingsOD = []
      this.omniPhoto(this.section).findingsOS = []
      this.omniPhoto(this.section).findingsOU = []

      this.normal = false
      this.normalStyle = false
      this.propagateFindings()
    },

    updtNormal() {
      if (this.normal != true) {
        this.selectedItemsOD = []
        this.selectedItemsOS = []
        this.normal_OD = true
        this.normal_OS = true
        this.selectedItemsOD.push(this.staticOptions("OD")[0])
        this.selectedItemsOS.push(this.staticOptions("OS")[0])
        this.normalStyle = "disabled"
      }
      this.propagateFindings()
    },

    normalODChanged(dxCard) {
      if (this.normal_OD != true) {
        this.nottested_OD = false
        this.removeDxOption(this.selectedItemsOD)
        this.selectedItemsOD = []
        this.selectedItemsOD.push(dxCard)
      } else {
        this.removeItemOD(this.staticOptions("OD")[0])
      }
      this.propagateFindings()
    },

    normalOSChanged(dxCard) {
      if (this.normal_OS != true) {
        this.nottested_OS = false
        this.removeDxOption(this.selectedItemsOS)
        this.selectedItemsOS = []
        this.selectedItemsOS.push(dxCard)
      } else {
        this.removeItemOS(this.staticOptions("OS")[0])
      }
      this.propagateFindings()
    },

    nottestedODChanged(dxCard) {
      if (this.nottested_OD != true) {
        this.selectedItemsOD = []
        this.selectedItemsOD.push(dxCard)
      }
      this.propagateFindings()
    },

    nottestedOSChanged(dxCard) {
      if (this.nottested_OS != true) {
        this.selectedItemsOS = []
        this.selectedItemsOS.push(dxCard)
      }
      this.propagateFindings()
    },
    clearFindings() {
      this.omniPhoto(this.section).fIDs.length = 0
    },
    newCheckFinding(item, event) {
      const isChecked = event.target.checked
      const value = event.target._value
      if (isChecked) {
        if (value.eye_affected === "OD" && this.normal_OD) {
          this.normal_OD = false
          this.removeItemOD(this.staticOptions("OD")[0]);
        } else if (value.eye_affected === "OS" && this.normal_OS) {
          this.normal_OS = false
          this.removeItemOS(this.staticOptions("OS")[0]);
        } else if (value.eye_affected === "OU" && this.normal_OU) {
          this.normal_OU = false
          this.removeItemOU(this.staticOptions("OU")[0]);
        }

        if (!value.isOtherFinding) {
          this.addDxOption(item)
        }

        return
      }

      this.removeDxOption([item])
    },
    propagateFindings() {
      this.clearFindings()

      this.omniPhoto(this.section).fIDs.push(...this.selectedItemsOD.map((item) => item.observation + ".OD"))
      this.omniPhoto(this.section).fIDs.push(...this.selectedItemsOU.map((item) => item.observation + ".OU"))
      this.omniPhoto(this.section).fIDs.push(...this.selectedItemsOS.map((item) => item.observation + ".OS"))

      this.omniPhoto(this.section).findingsOD = []
      this.omniPhoto(this.section).findingsOS = []
      this.omniPhoto(this.section).findingsOU = []
      this.omniPhoto(this.section).findingsOD.push(...this.selectedItemsOD.map((item) => item.observation))
      this.omniPhoto(this.section).findingsOS.push(...this.selectedItemsOS.map((item) => item.observation))
      this.omniPhoto(this.section).findingsOS.push(...this.selectedItemsOU.map((item) => item.observation))

      this.saveEval()

      this.$store.dispatch("loadSummary", null)
    },
    saveEval() {
      if (!this.section) {
        console.error("Section is not defined")
        return
      }
      let currentStorage = {}
      if (currentStorage[this.section] === undefined) {
        this.initCurrStorage()
      }

      let savedStorage = JSON.parse(localStorage.getItem(this.screeningID))

      if (savedStorage) {
        currentStorage = savedStorage
      }

      // Append savedEval to currentStorage
      currentStorage = { ...currentStorage, ...this.savedEval }

      // Update currentStorage
      currentStorage[this.section].OD = []
      currentStorage[this.section].OS = []
      currentStorage[this.section].OU = []

      const arrayOfIds = []

      this.selectedItemsOD.forEach((item) => {
        arrayOfIds.push(item.id)
        currentStorage[this.section].OD.push(item.observation)
      })
      this.selectedItemsOS.forEach((item) => {
        arrayOfIds.push(item.id)
        currentStorage[this.section].OS.push(item.observation)
      })
      this.selectedItemsOU.forEach((item) => {
        arrayOfIds.push(item.id)
        currentStorage[this.section].OU.push(item.observation)
      })

      this.updateSelectedFindingsIds({ section: this.section, ids: arrayOfIds })

      let newStorage = JSON.stringify(currentStorage)
      localStorage.setItem(this.screeningID, newStorage)
    },

    initCurrStorage() {
      this.screeningID = sessionStorage.getItem("screeningID")
      let currentStorage = {
        [this.section]: {
          OD: [],
          OS: [],
          OU: []
        }
      }

      let blankStorage = JSON.stringify(currentStorage)
      localStorage.setItem(this.screeningID, blankStorage)
    },

    addFinding(query, eyeAffected) {
      if (eyeAffected === "OD" && this.normal_OD) {
        this.normal_OD = false;
        this.removeItemOD(this.staticOptions("OD")[0]);
      } else if (eyeAffected === "OS" && this.normal_OS) {
        this.normal_OS = false;
        this.removeItemOS(this.staticOptions("OS")[0]);
      } else if (eyeAffected === "OU" && this.normal_OU) {
        this.normal_OU = false;
        this.removeItemOU(this.staticOptions("OU")[0]);
      }
      this.findingPayload = {
        eyeAffected: eyeAffected,
        name: query,
        modality: this.sectionName
      }
      const payload = {
        isCreate: true,
        finding: this.findingPayload,
        sectionName: this.sectionName
      }
      this.updateCreateFinding(payload)
    }
  }
}
</script>

<style lang="css" scoped>
.findings-control {
  /* max-width: 600px; */
  margin: 0 auto;
  /* font-family: Arial, sans-serif;
  font-size: 14px; */
}

.section-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
}

.section-column {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cards {
  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 100%;
  }
}
</style>
